import { signOut } from "firebase/auth";
import {
  clearFirebaseLocalStorage,
  initFirebase,
} from "@core/services/api/firebase";

export const logoutUser = async () => {
  try {
    // Ensure firebase is initialized
    const auth = await initFirebase();

    clearFirebaseLocalStorage();

    // Logout user
    return await signOut(auth);
  } catch (error) {
    throw error;
  }
};

export default logoutUser;

